import { CameraProjection } from './camera.models';

export class SetCameraProjection {
  static readonly type = '[Camera] SetCameraProjection';
  constructor(public readonly projection?: CameraProjection) {}
}
